import React from "react";
import { useParams, useNavigate } from "react-router-dom";

const AnalyticsList = ({ callBack, analyticTypes }) => {

    let { analyticId } = useParams();
    const navigate = useNavigate();

    return (
        <div className="container-fluid plans-component">
            <div className="row">
                <div className="col">
                    <h1 className="title">{gettext('Analytics')}</h1>
                </div>
            </div>
            <div className="row">
                <ul className="nav flex-column plan-list mb-5">
                    {analyticTypes !== false && analyticTypes.map((analyticType, i) => {
                        return (
                            <li className="nav-item" key={i}>
                                <div className={`nav-link ${analyticType.slug == analyticId ? 'active' : ''}`} onClick={() => { callBack(true), navigate(`/analytics/${analyticType.slug}`) }}>
                                    {analyticType.name}
                                </div>
                            </li>
                        )
                    })
                }
                </ul>
            </div>
        </div>

    )

}

export default AnalyticsList